import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=9628dd4c&scoped=true&"
var script = {}
import style0 from "./conversation.vue?vue&type=style&index=0&id=9628dd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9628dd4c",
  null
  
)

export default component.exports